module.exports = __webpack_public_path__ + "static/media/30_A.f5ab406b.png";